import {useCallback, useEffect} from "react";
import { getInternetUserList } from "actions/user";
import { getFieldRepList } from "actions/homeowner/fieldReps";
import { getAppraiserList } from "actions/appraiser";
import { searchCustomersText } from "actions/customer";
import { getSearchResults, getNewSearchResults } from "actions/search";

const searchFunctionByPathname = {
  ["/internet-user"]: getInternetUserList,
  ["/field-rep-list"]: getFieldRepList,
  ["/appraiser"]: getAppraiserList,
  ["/customer/search"]: searchCustomersText,
  ["/assignment-tool-insurance"]: text => getSearchResults(text, true),
  ["/assignment-tool-appraisal"]: text => getSearchResults(text, true),
};

const searchFunctionByRole = {
  ["Customer Service Rep"]: getSearchResults,
};

const getSearchFunctionByRoles = roles => 
  searchFunctionByRole[Object.keys(searchFunctionByRole).findIndex(role => roles.includes(role))];

const useSearchFunction = ({dispatch, roles = [], history, pathname, set}) => {

  const searchFunction = useCallback(
    searchText => {
      if (searchText){
        const baseSearchFunction = (
          searchFunctionByPathname[pathname] ||
          getSearchFunctionByRoles[roles] ||
          getNewSearchResults
        );
        dispatch(baseSearchFunction(searchText));
        const routeToPush = {
          [getSearchResults]: `${pathname.includes("webui") ? "/webui" : ""}/search-results`,
          [getNewSearchResults]: `${pathname.includes("webui") ? "/webui" : ""}/search-results`,
        }[baseSearchFunction];
        history.push({
          pathname: routeToPush || pathname,
          state: {
            searchText,
          },
        });
      }
    },
    [pathname, roles.length]
  );
  useEffect(
    () => set(searchFunction),
    [searchFunction]
  );
  return searchFunction;
};

export default useSearchFunction;